import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {classNames} from '../Support/classNames';
import {FeedbackFish} from '@feedback-fish/react';
import {FeedbackPresenter} from './FeedbackPresenter';
import {PresenterProps, withPresenter} from '../../Support/with_presenter';

interface OwnProps {
    className?: string;
}

const FeedbackComponent: FunctionComponent<OwnProps & PresenterProps<FeedbackPresenter>> = observer(
    ({className, presenter}) => {
        return (
            <div className={classNames('card', className)}>
                <div className="card-title">
                    <h5>Feedback</h5>
                </div>
                <div className="card-body">
                    <p>We're changing how you analyse your workouts.</p>
                    <p>Any suggestions, ideas or found a bug?</p>
                    <div className="d-flex flex-row justify-content-end">
                        <FeedbackFish projectId="9cb98325ae0265" userId={presenter.userId}>
                            <button className="btn btn-outline-secondary">Give feedback</button>
                        </FeedbackFish>
                    </div>
                </div>
            </div>
        );
    },
);

export const Feedback = withPresenter<FeedbackPresenter, OwnProps>(
    (props, component) => new FeedbackPresenter(component.network.me),
    FeedbackComponent,
);
